<template>
  <div class="flex flex-row justify-center">
    <div class="w-full max-w-max">
      <div class="sm:hidden">
        <label for="tabs" class="sr-only">Select a tab</label>
        <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
        <select
          id="tabs"
          name="tabs"
          class="block w-full focus:ring-[#5c7a2e] focus:border-[#5c7a2e] border-slate-300 rounded-md"
          @change="switchTab($event.target.value)"
        >
          <option
            v-for="(tab, tabIdx) in option_tabs"
            :key="tab.name"
            :value="tabIdx"
            :selected="tab.current"
          >
            {{ tab.name }}
          </option>
        </select>
      </div>
      <div class="hidden sm:block">
        <nav
          class="relative z-0 rounded-lg shadow divide-x divide-slate-200"
          aria-label="Tabs"
        >
          <a
            v-for="(tab, tabIdx) in option_tabs"
            :key="tab.name"
            href="#"
            @click.prevent="switchTab(tabIdx)"
            :class="[
              'whitespace-nowrap',
              tab.current
                ? 'text-slate-900'
                : 'text-slate-500 hover:text-slate-700',
              tabIdx === 0 ? 'rounded-l-lg' : '',
              tabIdx === option_tabs.length - 1 ? 'rounded-r-lg' : '',
              'group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-slate-50 focus:z-10',
            ]"
            :aria-current="tab.current ? 'page' : undefined"
          >
            <i :class="tab.icon"></i>
            <span class="space-icon"></span>
            <span>{{ tab.name }}</span>
            <span
              aria-hidden="true"
              :class="[
                tab.current ? 'bg-[#5c7a2e]' : 'bg-transparent',
                'absolute inset-x-0 bottom-0 h-0.5',
              ]"
            />
          </a>
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TabsContainer",
  data() {
    return {
      option_tabs: this.modelValue,
      load_data: false,
    };
  },
  props: {
    modelValue: {},
    with_routing: {
      type: Boolean,
      default: false, // cuando sea true, al elegir un tab, cambiara a la ruta nombrada en el atributo route?.params de la opción
    },
  },
  computed: {
    current_tab: function () {
      return this.option_tabs.find((tab) => tab.current) || null;
    },
    current_tab_route_name: function () {
      if (this.with_routing) return this.current_tab?.route?.name || "";
      else return "";
    },
    current_tab_route_params: function () {
      if (this.with_routing)
        return (
          this.current_tab?.route?.params ||
          this.$router.currentRoute._value.params
        );
      else return "";
    },
  },
  created: function () {
    this.loadData();
  },
  methods: {
    loadData: async function () {
      if (this.with_routing) {
        await this.setCurrentTabByRoute();
      }
      this.load_data = true;
    },
    setCurrentTabByRoute: function () {
      this.option_tabs.forEach((option_tab) => {
        option_tab.current =
          this.$router.currentRoute._value.name == option_tab.route?.name;
      });
    },
    switchTab: function (tabIdx) {
      for (let i = 0; i < this.option_tabs.length; i++) {
        this.option_tabs[i].current = false;
      }
      this.option_tabs[tabIdx].current = true;
      this.$emit("update:modelValue", { ...this.option_tabs });
    },
  },
  watch: {
    current_tab_route_name: function (new_value, old_value) {
      if (this.with_routing && new_value && new_value != old_value)
        this.$router.push({
          name: new_value,
          params: this.current_tab_route_params,
        });
    },
  },
};
</script>
